import useMutation from "src/hooks/useMutation";

function useWarehouseCreate() {
  return useMutation({
    path: "/api/v1/warehouses",
    method: "POST",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/warehouses`,
      shouldRevalidate: true,
    },
  });
}

export default useWarehouseCreate;
